import { AnyAction } from 'redux'
import { Actions } from '../actions/calendar-activities'
import { CalendarActivitiesState } from '../states/calendarActivitiesState'
import { formatDate } from '@/app/utils/commonFunctions'

export const CALENDAR_ACTIVITIES_REDUCER_NAMESPACE = 'calendarActivitiesReducer'

const defaultState: CalendarActivitiesState = {
    activities: [],
    loading: false,
    filters: {
        page: 1,
        page_size: 10,
        tab: 'to_me',
        type: {
            value: ['task'],
        },
    },
    totalCalendarActivities: 0,
    selectedDate: formatDate(new Date().toString()),
}

export default (state: CalendarActivitiesState = defaultState, action: AnyAction) => {
    switch (action.type) {
        case Actions.GET_CALENDAR_ACTIVITIES_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case Actions.GET_CALENDAR_ACTIVITIES_SUCCESS:
            return {
                ...state,
                activities: [...state.activities, ...action.activities],
                loading: false,
            }
        case Actions.GET_CALENDAR_ACTIVITIES_FAILURE:
            return {
                ...state,
                loading: false,
            }
        case Actions.RESET_CALENDAR_ACTIVITIES:
            return {
                ...state,
                activities: [],
            }
        case Actions.SET_SELECTED_DATE:
            return {
                ...state,
                selectedDate: action.selectedDate,
            }
        case Actions.SET_CALENDAR_ACTIVITIES_FILTERS:
            return {
                ...state,
                filters: { ...state.filters, ...action.filters },
            }
        case Actions.SET_TOTAL_CALENDAR_ACTIVITIES:
            return {
                ...state,
                totalCalendarActivities: action.totalCalendarActivities,
            }
        default:
            return state
    }
}
